module.exports = "/_next/static/images/Error-1cf5b1c4a99d1faec03c30c5e9fd5e64.webp";